<template>
	<el-dialog title="预览数据" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
		<span>表格数据</span>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialogVisible: false
		};
	},
	methods: {
		loadData(){
			this.dialogVisible = true
		}
	}
};
</script>

<style></style>
